import type { SessionErrorHandler } from "../tastyworks"
import HttpClient, { type Transport } from "../tastyworks/http"
import type Logger from "../tastyworks/logger"
import AnalystConsensusService from "./services/analyst-consensus"
import DxScriptsService from "./services/dx-scripts"
import FinancialStatementService from "./services/financial-statement"
import NewsService from "./services/news"
import { QuoteAlertService } from "./services/quote-alerts"
import SnapshotService from "./services/snapshot"
import SymbolSearchService from "./services/symbol-search"
import type { TwRestSession } from "./session"

export class VastClient {
  private readonly baseHttpClient: HttpClient

  private readonly refinitivHttpClient: HttpClient

  readonly fetcher: typeof fetch

  readonly analystConsensusService: AnalystConsensusService

  readonly dxScriptsService: DxScriptsService

  readonly financialStatementService: FinancialStatementService

  readonly newsService: NewsService

  readonly quoteAlertService: QuoteAlertService

  readonly snapshotService: SnapshotService

  readonly symbolSearchService: SymbolSearchService

  constructor(
    vastBaseUrl: string,
    logger: Logger,
    fetcher: typeof fetch,
    sessionErrorHandler: SessionErrorHandler,
    twSession: TwRestSession,
    transport: Transport | (() => Transport) = "bearer"
  ) {
    this.fetcher = fetcher
    this.baseHttpClient = new HttpClient(
      logger,
      fetcher,
      vastBaseUrl,
      twSession,
      sessionErrorHandler,
      undefined,
      {},
      transport
    )

    this.refinitivHttpClient = this.baseHttpClient.nested(
      "/refinitiv-proxy/tasty"
    )

    this.analystConsensusService = new AnalystConsensusService(
      this.refinitivHttpClient
    )
    this.dxScriptsService = new DxScriptsService(this.baseHttpClient)
    this.financialStatementService = new FinancialStatementService(
      this.refinitivHttpClient
    )
    this.newsService = new NewsService(this.refinitivHttpClient)
    this.quoteAlertService = new QuoteAlertService(this.baseHttpClient)
    this.snapshotService = new SnapshotService(this.refinitivHttpClient)
    this.symbolSearchService = new SymbolSearchService(
      this.baseHttpClient.nested("symbols")
    )
  }
}
